import * as ECGConstants from '../constants/ECGs';
import {getPagination} from "src/modules/app/actions/SaveTablePagination";

const initialState = {
  collection: [],
  isFetching: false,
  isLoaded: false,
  pagination: {
    total: 0,
    perPage: getPagination("ECGs").perPage,
    totalPages: 0,
    page: 0
  },
  sorting: {
    sort: 'desc',
    order: 'measured_at'
  },
  timeInterval: {
    from: null,
    to: null
  }
};

export function ecgs(state = initialState, action) {
  switch (action.type) {
    case ECGConstants.FETCH_STARTED:
      return Object.assign({}, state, {isFetching: true, collection: initialState.collection});
    case ECGConstants.FETCH_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        collection: action.ecgs,
        pagination: action.pagination,
        sorting: action.sorting
      });
    default:
      return state;
  }
}
